<app-layout>
  <div class="px-[0.88rem] md:pt-[4.5rem]" primary>
    @if (response && response.surveyTitle) {
      <h1
        class="font-normal text-[2.5rem] text-inherit mb-6"
        [innerHTML]="response.surveyTitle | safeHtml"
      ></h1>
    }

    @if (startOverView) {
      <section role="region" aria-labelledby="startover-header">
        <h2 id="startover-header" class="text-inherit font-normal">
          {{ "startover.header" | translate }}
        </h2>

        <p class="mt-6" id="startover-whattodo">
          {{ "startover.whattodo" | translate }}
        </p>

        <app-button
          buttonId="startover-btn"
          (buttonClick)="startOver(startOverUrl)"
          customHostClasses="w-full"
          [buttonText]="'startover.startfrombeginning.button' | translate"
          [buttonType]="'button'"
          customClasses="flex items-center justify-center w-full h-[46px] uppercase text-sm xs:text-lg md:text-xl lg:hover:font-bold lg:hover:scale-y-[1.02] lg:hover:scale-x-[1.005]"
          [describedBy]="'startover-whattodo'"
        ></app-button>
      </section>
    }
  </div>

  <app-navigation
    (nextClick)="startOver(continueUrl)"
    [nextButtonText]="'startover.continue.button' | translate"
    navigation
  ></app-navigation>

  @if (chooseLanguageComponent) {
    <app-choose-language
      appLanguage
      class="mr-2 lg:mr-4"
      [showFlags]="chooseLanguageComponent.showFlags"
      (selectedLanguage)="setLanguage($event)"
      [defaultLanguage]="response.language"
      [options]="languageOptions"
      [translationKeys]="['startover.']"
      [fallbackLanguage]="response.fallbackLanguage"
    ></app-choose-language>
  }
</app-layout>
